import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Select from "react-select";
import { useFormik } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { adminMainUrl } from "../../../../../../Config";


const AddCargoDlts = ({
  showAdd,
  handleCloseAdd,
  token,
  user_id,
  b64id,
  JobOrderEmployeeList,
  loadingJobOrderCargoDetail,
  JobOrderCargoDetailError,
  JobOrderCargoDetail,
  refreshCargo,
  JobOrderCommodityList,
  loadingJobOrderCommodityList,
  refreshCargoDtls
}) => {


  const [disableSubmit, setDisableSubmit] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [employeeOptions, setEmployeeOptions] = useState([]);


  const [commodityOptions, setCommodityOptions] = useState([]);
  useEffect(() => {
    if (JobOrderCommodityList) {
      let arr = [];
      JobOrderCommodityList.map(val => { arr.push({ value: val.id, label: val.name }) });
      setCommodityOptions(arr);
    }
  }, [loadingJobOrderCommodityList, JobOrderCommodityList])


  const initialValues = {
    description: "",
    packages_type: "",
    packages_count: "",
    commodity_id: "",
    inner_pkgs_type: "",
    inner_pkgs_count: "",
    commodity_type: "",
    gross_weight_type: "",
    gross_weight: "",
    hs_code: "",
    net_weight_type: "",
    net_weight: "",
    dimension_type: "",
    dimension_length: "",
    dimension_height: "",
    dimension_width: "",
    volume_type: "",
    total_volume: "",
    volume_weight: "",
    marks_and_nos: "",
    chargeable_wt: "",
    chargeable_wt_type: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values, { resetForm }) => {
      // console.log(values);
      setDisableSubmit(true);
      try {
        let config = {
          headers: {
            "auth-token": token,
            user_id: user_id,
          },
        };
        values.job_order_id = atob(b64id);
        axios
          .post(`${adminMainUrl}/api/jobOrder/cargo/add`, values, config)
          .then((response) => {
            if (response.status == 200) {
              toast.success(response?.data?.msg);
              setDisableSubmit(false);
              handleCloseAdd();
              resetForm();
              refreshCargoDtls();
              // refresh();
              // refreshCargo();
            } else {
              toast.error(response?.data?.msg);
              setDisableSubmit(false);
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error.response.data.msg);
            setDisableSubmit(false);
          });
      } catch (error) {
        console.log(error.message);
        toast.error(error.message);
        setDisableSubmit(false);
      }
    },
  });

  useEffect(() => {
    if (loadingJobOrderCargoDetail) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }

    if (JobOrderCargoDetail) {
      formik.setFieldValue("description", JobOrderCargoDetail?.description);
      formik.setFieldValue("packages_type", JobOrderCargoDetail?.packages_type);
      formik.setFieldValue(
        "packages_count",
        JobOrderCargoDetail?.packages_count
      );
      formik.setFieldValue("commodity_id", JobOrderCargoDetail?.commodity_id);
      formik.setFieldValue(
        "inner_pkgs_type",
        JobOrderCargoDetail?.inner_pkgs_type
      );
      formik.setFieldValue(
        "inner_pkgs_count",
        JobOrderCargoDetail?.inner_pkgs_count
      );
      formik.setFieldValue(
        "commodity_type",
        JobOrderCargoDetail?.commodity_type
      );
      formik.setFieldValue(
        "gross_weight_type",
        JobOrderCargoDetail?.gross_weight_type
      );
      formik.setFieldValue("gross_weight", JobOrderCargoDetail?.gross_weight);
      formik.setFieldValue("hs_code", JobOrderCargoDetail?.hs_code);
      formik.setFieldValue("net_weight", JobOrderCargoDetail?.net_weight);
      formik.setFieldValue(
        "dimension_type",
        JobOrderCargoDetail?.dimension_type
      );
      formik.setFieldValue(
        "dimension_length",
        JobOrderCargoDetail?.dimension_length
      );
      formik.setFieldValue(
        "dimension_height",
        JobOrderCargoDetail?.dimension_height
      );
      formik.setFieldValue(
        "dimension_width",
        JobOrderCargoDetail?.dimension_width
      );
      formik.setFieldValue("volume_type", JobOrderCargoDetail?.volume_type);
      formik.setFieldValue("total_volume", JobOrderCargoDetail?.total_volume);
      formik.setFieldValue("volume_weight", JobOrderCargoDetail?.volume_weight);
      formik.setFieldValue("marks_and_nos", JobOrderCargoDetail?.marks_and_nos);
      formik.setFieldValue("chargeable_wt", JobOrderCargoDetail?.chargeable_wt);
    }
  }, [
    loadingJobOrderCargoDetail,
    JobOrderCargoDetailError,
    JobOrderCargoDetail,
    employeeOptions,
  ]);

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 29,
      minHeight: 29,
      display: 'flex',
      alignItems: 'center',
    }),
    placeholder: (base) => ({
      ...base,
      display: 'flex',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: "600",
      color: '#808080',
    }),
    menu: (base) => ({
      ...base,
      fontSize: '12px',
    }),
    option: (base) => ({
      ...base,
      fontSize: '12px',
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '12px',
      display: 'flex', // Ensure singleValue aligns center vertically
      alignItems: 'center',
    }),
  };

  return (
    <>
      <Offcanvas show={showAdd} onHide={handleCloseAdd} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add Cargo Dtls</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              {/* Description */}
              <div className="col-md-12 mt-2">
                <label htmlFor="description" className="form-label ">
                  Description
                </label>
                <textarea
                  className="form-control "
                  id="description"
                  rows={3}
                  maxLength={250}
                  name="description"
                  onChange={(e) => {
                    formik.setFieldValue("description", e.target.value);
                  }}
                  value={formik.values.description}
                ></textarea>
              </div>
              {/* Packages */}
              <div className="col-md-6 mt-2">
                <label htmlFor="packages" className="form-label ">
                  Packages
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={15}
                    className="form-control form-control-sm"
                    id="packages_count"
                    name="packages_count"
                    onChange={(e) => {
                      formik.setFieldValue("packages_count", e.target.value);
                    }}
                    value={formik.values.packages_count}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9]/g, '');
                      event.target.value = value;
                    }}

                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="packages_type"
                    name="packages_type"
                    onChange={(e) => {
                      formik.setFieldValue("packages_type", e.target.value);
                    }}
                    value={formik.values.packages_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
                </div>
              </div>
              {/* Inner Packages */}
              <div className="col-md-6 mt-2">
                <label htmlFor="inner_packages" className="form-label ">
                  Inner Pkgs
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={15}
                    className="form-control form-control-sm"
                    id="inner_pkgs_count"
                    name="inner_pkgs_count"
                    onChange={(e) => {
                      formik.setFieldValue("inner_pkgs_count", e.target.value);
                    }}
                    value={formik.values.inner_pkgs_count}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9]/g, '');
                      event.target.value = value;
                    }}

                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="inner_pkgs_type"
                    name="inner_pkgs_type"
                    onChange={(e) => {
                      formik.setFieldValue("inner_pkgs_type", e.target.value);
                    }}
                    value={formik.values.inner_pkgs_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="NOS">NOS</option>
                    <option value="BAG">BAG (Bags)</option>
                    <option value="BGS">BGS (BAGS)</option>
                    <option value="BLK">BLK (Bulk)</option>
                    <option value="BLO">BLO (Steel Blocks)</option>
                    <option value="BLS">BLS (Bails)</option>
                    <option value="BOX">BOX (Boxes)</option>
                    <option value="BRL">BRL (Barrel)</option>
                    <option value="BTL">BTL (Bottles)</option>
                    <option value="BUL">BUL (Steel Bulk)</option>
                    <option value="CAN">CAN (Cans)</option>
                    <option value="CHI">CHI (Chest)</option>
                    <option value="COL">COL (Collies)</option>
                    <option value="CON">CON (Container)</option>
                    <option value="CRI">CRI (Crates)</option>
                    <option value="CRY">CRY (Carboys)</option>
                    <option value="CSK">CSK (Wooden Cases)</option>
                    <option value="CTN">CTN (Cartons)</option>
                    <option value="CYL">CYL (Cylinder)</option>
                    <option value="DOZ">DOZ (Dozen)</option>
                    <option value="DRM">DRM (Drums)</option>
                    <option value="ENV">ENV (Steel Envelopes)</option>
                    <option value="FBK">FBK (Habbuck)</option>
                    <option value="FLK">FLK (Flask)</option>
                    <option value="FUT">FUT (Futs)</option>
                    <option value="GRS">GRS (Gross)</option>
                  </select>
                </div>
              </div>
              {/* Gross Weight */}
              <div className="col-md-6 mt-2">
                <label htmlFor="gross_weight" className="form-label ">
                  Gross Weight
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={20}
                    className="form-control form-control-sm"
                    id="gross_weight"
                    name="gross_weight"
                    onChange={(e) => {
                      formik.setFieldValue("gross_weight", e.target.value);
                    }}
                    value={formik.values.gross_weight}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9.]/g, '');
                      const parts = value.split('.');
                      if (parts.length > 2) {
                        value = parts[0] + '.' + parts[1];
                      }
                      event.target.value = value;
                    }}

                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="gross_weight_type"
                    name="gross_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("gross_weight_type", e.target.value);
                    }}
                    value={formik.values.gross_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="CAR">CAR (Carat)</option>
                    <option value="CTM">CTM (CARATS)</option>
                    <option value="GMS">GMS (Gram)</option>
                    <option value="KGS">KGS (Kilogram)</option>
                    <option value="LBS">LBS (POUNDS)</option>
                    <option value="MGR">MGR (Milligram)</option>
                    <option value="MTS">MTS (Metric Ton)</option>
                    <option value="PND">PND (Pound)</option>
                    <option value="QTL">QTL (Quintal)</option>
                    <option value="TGM">TGM (Ten Gross)</option>
                    <option value="TON">TON (Long Ton)</option>
                  </select>
                </div>
              </div>
              {/* Net Weight */}
              <div className="col-md-6 mt-2">
                <label htmlFor="net_weight" className="form-label ">
                  Net Weight
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={20}
                    className="form-control form-control-sm"
                    id="net_weight"
                    name="net_weight"
                    onChange={(e) => {
                      formik.setFieldValue("net_weight", e.target.value);
                    }}
                    value={formik.values.net_weight}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9.]/g, '');
                      const parts = value.split('.');
                      if (parts.length > 2) {
                        value = parts[0] + '.' + parts[1];
                      }
                      event.target.value = value;
                    }}
                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="net_weight_type"
                    name="net_weight_type"
                    onChange={(e) => {
                      formik.setFieldValue("net_weight_type", e.target.value);
                    }}
                    value={formik.values.net_weight_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="CAR">CAR (Carat)</option>
                    <option value="CTM">CTM (CARATS)</option>
                    <option value="GMS">GMS (Gram)</option>
                    <option value="KGS">KGS (Kilogram)</option>
                    <option value="LBS">LBS (POUNDS)</option>
                    <option value="MGR">MGR (Milligram)</option>
                    <option value="MTS">MTS (Metric Ton)</option>
                    <option value="PND">PND (Pound)</option>
                    <option value="QTL">QTL (Quintal)</option>
                    <option value="TGM">TGM (Ten Gross)</option>
                    <option value="TON">TON (Long Ton)</option>
                  </select>
                </div>
              </div>
              {/* Dimension */}
              <div className="col-md-6 mt-2">
                <label htmlFor="dimension" className="form-label ">
                  Dimension
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={15}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9.]/g, '');
                      const parts = value.split('.');
                      if (parts.length > 2) {
                        value = parts[0] + '.' + parts[1];
                      }
                      event.target.value = value;
                    }}
                    className="form-control form-control-sm"
                    id="dimension_length"
                    placeholder={0.0}
                    name="dimension_length"
                    onChange={(e) => {
                      formik.setFieldValue("dimension_length", e.target.value);
                    }}
                    value={formik.values.dimension_length}
                  />
                  <span className="mx-1">x</span>
                  <input
                    type="text"
                    maxLength={15}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9.]/g, '');
                      const parts = value.split('.');
                      if (parts.length > 2) {
                        value = parts[0] + '.' + parts[1];
                      }
                      event.target.value = value;
                    }}
                    className="form-control form-control-sm"
                    id="dimension_width"
                    placeholder={0.0}
                    name="dimension_width"
                    onChange={(e) => {
                      formik.setFieldValue("dimension_width", e.target.value);
                    }}
                    value={formik.values.dimension_width}
                  />
                  <span className="mx-1">x</span>
                  <input
                    type="text"
                    maxLength={15}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9.]/g, '');
                      const parts = value.split('.');
                      if (parts.length > 2) {
                        value = parts[0] + '.' + parts[1];
                      }
                      event.target.value = value;
                    }}
                    className="form-control form-control-sm"
                    id="dimension_height"
                    placeholder={0.0}
                    name="dimension_height"
                    onChange={(e) => {
                      formik.setFieldValue("dimension_height", e.target.value);
                    }}
                    value={formik.values.dimension_height}
                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="dimension_type"
                    name="dimension_type"
                    onChange={(e) => {
                      formik.setFieldValue("dimension_type", e.target.value);
                    }}
                    value={formik.values.dimension_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="CMS">CMS</option>
                    <option value="INC">INC</option>
                    <option value="MTR">MTR</option>
                  </select>
                </div>
              </div>
              {/* Volume */}
              <div className="col-md-6 mt-2">
                <label htmlFor="volume" className="form-label ">
                  Volume
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={20}
                    className="form-control form-control-sm"
                    id="total_volume"
                    name="total_volume"
                    onChange={(e) => {
                      formik.setFieldValue("total_volume", e.target.value);
                    }}
                    value={formik.values.total_volume}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9.]/g, '');
                      const parts = value.split('.');
                      if (parts.length > 2) {
                        value = parts[0] + '.' + parts[1];
                      }
                      event.target.value = value;
                    }}
                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="volume_type"
                    name="volume_type"
                    onChange={(e) => {
                      formik.setFieldValue("volume_type", e.target.value);
                    }}
                    value={formik.values.volume_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="CBI">CBI (Cubic Inch)</option>
                    <option value="CBM">CBM (Cubic metre)</option>
                    <option value="CCM">CCM (Cubic Centimetre)</option>
                    <option value="CFT">CFT (Cubic foot)</option>
                    <option value="KLT">KLT (Kilo Litre)</option>
                    <option value="LTR">LTR (Litre)</option>
                    <option value="PNT">PNT (Pint)</option>
                    <option value="UGS">UGS (US Gallons)</option>
                  </select>
                </div>
              </div>
              {/* Commodity */}
              <div className="col-md-6 mt-2">
                <label htmlFor="commodity" className="form-label ">
                  Commodity
                </label>
                <Select
                  id="commodity_id"
                  placeholder="Select Commodity"
                  className='custom-selector w-100'
                  options={commodityOptions}
                  styles={customStyles}
                  name="commodity_id"
                  onChange={option => {
                    formik.setFieldValue('commodity_id', option.value);
                  }}
                  value={commodityOptions.find(option => option.value === formik.values.commodity_id) || null}
                />

              </div>
              {/* Commodity Type */}
              <div className="col-md-6 mt-2">
                <label htmlFor="commodity_type" className="form-label ">
                  Commodity Type
                </label>
                <select
                  className="form-control form-control-sm"
                  id="commodity_type"
                  name="commodity_type"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.commodity_type}
                >
                  <option value="" disabled>-</option>
                  <option value="Non-Hazardous" >Non-Hazardous</option>
                  <option value="Hazardous">Hazardous</option>
                  <option value="Perishable">Perishable</option>
                </select>
              </div>
              {/* HS Code */}
              <div className="col-md-6 mt-2">
                <label htmlFor="hs_code" className="form-label ">
                  HS Code
                </label>
                <input
                  type="text"
                  maxLength={20}
                  className="form-control form-control-sm"
                  id="hs_code"
                  name="hs_code"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.hs_code}
                  // onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ''))}

                />
              </div>
              {/* Volume Weight */}
              <div className="col-md-6 mt-2">
                <label htmlFor="volume_weight" className="form-label ">
                  Volume Weight
                </label>
                <input
                  type="text"
                  maxLength={20}
                  className="form-control form-control-sm"
                  id="volume_weight"
                  step="0.001"
                  placeholder={0.0}
                  name="volume_weight"
                  onChange={formik.handleChange}
                  value={formik.values.volume_weight}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    const parts = value.split('.');
                    if (parts.length > 2) {
                      value = parts[0] + '.' + parts[1];
                    }
                    event.target.value = value;
                  }}
                />
              </div>
              {/* Chargeable Weight */}
              <div className="col-md-6 mt-2">
                <label htmlFor="chargeable_weight" className="form-label ">
                  Chargeable Wt
                </label>
                <div className="d-flex">
                  <input
                    type="text"
                    maxLength={20}
                    className="form-control form-control-sm"
                    id="chargeable_wt"
                    step="0.001"
                    placeholder={0.0}
                    name="chargeable_wt"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.chargeable_wt}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9.]/g, '');
                      const parts = value.split('.');
                      if (parts.length > 2) {
                        value = parts[0] + '.' + parts[1];
                      }
                      event.target.value = value;
                    }}
                  />
                  <select
                    className="form-control form-control-sm ms-2"
                    id="chargeable_wt_type"
                    name="chargeable_wt_type"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.chargeable_wt_type}
                  >
                    <option value="" disabled>-</option>
                    <option value="KGS">KGS</option>
                    <option value="MTS">MTS</option>
                  </select>
                </div>
              </div>
              {/* Marks and Nos */}
              <div className="col-md-6 mt-2">
                <label htmlFor="marks_and_nos" className="form-label ">
                  Marks and Nos
                </label>
                <textarea
                  className="form-control"
                  id="marks_and_nos"
                  rows={2}
                  maxLength={250}
                  name="marks_and_nos"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.marks_and_nos}
                />
              </div>
            </div>

            <div className="row d-flex justify-content-end my-2">
              <div className="col-md-6 d-flex justify-content-end">
                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                  {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                </button>
              </div>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas >
    </>
  )
}

export default AddCargoDlts